import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cml_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Our own message from a failed call, or nothing. Gateway error pages (HTML, plain text)
// are never shown to the reader — the caller's own friendly line is used instead.
export function errorDetail(e) {
  const body = e?.response?.data;
  if (!body || typeof body !== "object" || Array.isArray(body)) return "";
  const { detail } = body;
  if (!detail) return "";
  return apiError(detail);
}

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
